import React from 'react';

const AnimationD = ({ visible = true}) => {
  return (
    <div className="marcasAnimation" style={{opacity: visible ? '1':'0'}}>
      <video disableRemotePlayback className="FantasmaAtaca" playsInline webkit-playsInline muted autoPlay loop>
        <source src="/animations/fantasmaataca.webm" type="video/webm" />
        <source src="/animations/fantasmaataca.mp4" type="video/mp4" />
      </video>
      <video disableRemotePlayback className="CocoDerrotado" playsInline webkit-playsInline muted autoPlay loop>
        <source src="/animations/derrotadocomecoco.webm" type="video/webm" />
        <source src="/animations/derrotadocomecoco.mp4" type="video/mp4" />
      </video>
      <style jsx>
        {`
          .marcasAnimation {
            display:flex;
            height:auto;
            align-items:center;
            .FantasmaAtaca {
              height:3.18rem;
              width:auto;
              margin-right:2rem;
            }
            .CocoDerrotado {
              height:5.75rem;
              width:auto;
            }
          }
          
        @media screen and (max-width:700px) {
          .marcasAnimation  {
            position:absolute;
            height:3rem;
            transform:translate(0%, -100%);
            .FantasmaAtaca{
              height:3rem;
            }
            .CocoDerrotado {
              height:5.5rem;
            }
          }
          @media screen and (max-width:580px) {
            .marcasAnimation  {
              position:absolute;
              height:3rem;
              transform:translate(0%, -110%);
              .FantasmaAtaca{
                height:2.5rem;
                margin-right:1rem;
              }
              .CocoDerrotado {
                height:5rem;
              }
            }
          }
          @media screen and (max-width:580px) {
            .marcasAnimation  {
              .FantasmaAtaca{
                height:2.5rem;
              }
              .CocoDerrotado {
                height:4.8rem;
              }
            }
          }
          
          }
        `}
      </style>
    </div>
  )
}


export default AnimationD;
